import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AllDataService {
    private authStatusListener = new Subject<boolean>();
    public err = new BehaviorSubject<any>(null);
    constructor(private http: HttpClient) {}

    exportAllData() {
        var options = {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('token'),
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        };
        return new Promise<object>((resolve, reject) => {
            this.http
                .get(environment.backEndUrl + '/httpConstantAll')
                .toPromise()
                .then((data) => {
                    localStorage.setItem('data', JSON.stringify(data));
                    this.err.next(null);
                });
        });
    }
}
